module.exports = __webpack_public_path__ + "static/service-strategies-46168c6ecc4e664327651572144ee8a2.png";